import {REPORT_ISSUE} from 'src/pages/scheduleCallback/constants/flows';
import {authenticate, AUTH} from 'src/shared/auth/actions';
import {datacast, READ_DATACAST_COMPLETE} from 'src/shared/datacast/actions';
import {hasProactiveIssueDetectionSegment} from 'src/shared/datacast/selectors';
import {loadHic, LOAD_HIC_COMPLETE} from 'src/shared/hic/actions';
import {preloadItgRecommendations} from 'src/shared/itgRecommendations/actions';
import {loadOutages, LOAD_OUTAGES_COMPLETE} from 'src/shared/outages/actions';
import {loadUser, LOAD_USER_COMPLETE} from 'src/shared/user/actions';
import {loadWatchtower, LOAD_WATCHTOWER_COMPLETE} from 'src/shared/watchtower/actions';
import {readAccount, READ_ACCOUNT_COMPLETE} from 'src/shared/account/actions';
import {readReportIssueEligibility, READ_REPORT_ISSUE_ELIGIBILITY_COMPLETE} from 'src/shared/reportIssue/actions';
import {redirect, setRedirectUrl} from 'src/shared/redirect/actions';
import {reportIssueEligible} from 'src/shared/reportIssue/selectors';
import {startDataLayerTracking} from 'src/shared/dataLayer/actions';
import {
  scheduleCallback,
  status,
} from 'src/shared/pagePaths';
import {waitUntil} from 'src/shared/events';
import {watchtower} from 'src/shared/watchtower/selectors';
import {changeView} from 'src/shared/currentView/actions';
import {SMS_ENROLLMENT} from 'src/pages/reportIssue/constants/views';
import {mobileNumber} from 'src/shared/user/selectors';
import {setSmsNumber} from 'src/pages/reportIssue/store/actions/creators';

export const start = () => async (dispatch, getState) => {
  dispatch(authenticate({requiresAuthentication: true}));
  dispatch(startDataLayerTracking());
  dispatch(setRedirectUrl(status()));
  dispatch(loadUser());
  dispatch(readAccount());
  dispatch(loadHic());
  dispatch(loadWatchtower());
  dispatch(datacast());
  dispatch(loadOutages());
  await waitUntil(AUTH);

  dispatch(readReportIssueEligibility());

  await waitUntil(
    LOAD_HIC_COMPLETE,
    LOAD_OUTAGES_COMPLETE,
    READ_ACCOUNT_COMPLETE,
    READ_DATACAST_COMPLETE,
    READ_REPORT_ISSUE_ELIGIBILITY_COMPLETE
  );
  if (hasProactiveIssueDetectionSegment(getState())) {
    dispatch(preloadItgRecommendations());
  }
  if (!reportIssueEligible(getState())) {
    return dispatch(redirect(status()));
  }

  await waitUntil(LOAD_WATCHTOWER_COMPLETE);
  if (watchtower(getState())) {
    return dispatch(changeView(SMS_ENROLLMENT));
  }
  await waitUntil(LOAD_USER_COMPLETE);
  if (mobileNumber(getState())) {
    dispatch(setSmsNumber(mobileNumber(getState())));
  }

  return dispatch(redirect((scheduleCallback({flow: REPORT_ISSUE}))));
};
